"use client"

import { useState } from "react"

import { Button as HeadlessButton, Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react"
import { useLocale, useTranslations } from "next-intl"
import { flushSync } from "react-dom"

import { Stack, Text } from "@/components/ui"
import { CloseButton } from "@/components/ui/close-button"

// CAT (Costo Anual Total) figures for Tienda Nelo, sin IVA. Update here when the
// folleto figures are refreshed, together with the calculation date.
const TIENDA_NELO_CAT = "16"
const TIENDA_NELO_APR = "8"
const CAT_CALC_DATE = { "es-MX": "agosto de 2026", "en-US": "August 2026" } as const

export const CatDisclosure = () => {
  const t = useTranslations("catDisclosure")
  const locale = useLocale() as keyof typeof CAT_CALC_DATE
  const [open, setOpen] = useState(false)
  const [mounted, setMounted] = useState(false)
  const show = () => {
    flushSync(() => setMounted(true))
    setOpen(true)
  }

  return (
    <>
      <HeadlessButton
        onClick={show}
        aria-haspopup="dialog"
        className="font-text text-body text-fg hover:text-fg-brand duration-quick ease-productive flex w-fit cursor-pointer items-center gap-100 transition-colors"
      >
        {t("trigger")}
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.25" />
          <path d="M8 7v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="8" cy="4.75" r="0.85" fill="currentColor" />
        </svg>
      </HeadlessButton>
      {mounted && (
        <Dialog open={open} onClose={setOpen} transition className="relative">
          <DialogBackdrop className="bg-scrim-strong z-modal-backdrop ease-productive duration-moderate fixed inset-0 transition data-closed:opacity-0" />
          <div className="z-modal fixed inset-0 flex items-center justify-center p-500">
            <DialogPanel
              transition
              className="bg-surface rounded-12x shadow-floating ease-expressive duration-moderate w-full max-w-120 p-800 opacity-100 transition data-closed:translate-y-2 data-closed:opacity-100 motion-reduce:transition-none"
            >
              <div className="flex items-start justify-between gap-400">
                <DialogTitle className="font-text text-heading-lg text-fg font-light">{t("title")}</DialogTitle>
                <CloseButton onClick={() => setOpen(false)} />
              </div>
              <div className="mt-600">
                <Text variant="lede" family="text">
                  {t("product")}
                </Text>
                <Stack gap="50" className="mt-150">
                  <Text variant="bodyLg" family="text" numeric>
                    {t("cat", { value: TIENDA_NELO_CAT })}
                  </Text>
                  <Text variant="bodyLg" family="text" numeric>
                    {t("apr", { value: TIENDA_NELO_APR })}
                  </Text>
                </Stack>
              </div>
              <Text variant="body" family="text" className="mt-600">
                {t("noRevolving")}
              </Text>
              <Text variant="bodySm" family="text" tone="subtle" className="mt-300">
                {t("disclaimer", { date: CAT_CALC_DATE[locale] })}
              </Text>
            </DialogPanel>
          </div>
        </Dialog>
      )}
    </>
  )
}
